/**
 * Message Provider 组件
 * 用于注册全局 message 实例，供 axios 拦截器使用
 */
import { useEffect } from 'react'
import { App } from 'antd'
import { registerMessage } from '@/utils/messageProvider'

const MessageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { message } = App.useApp()

  useEffect(() => {
    // 注册 message 实例到全局服务
    registerMessage(message)
  }, [message])

  return <>{children}</>
}

export default MessageProvider
